import React from 'react';
import { arrayOf, shape, string, func } from 'prop-types';
import { Heading } from '@tesla/design-system-react';
import CountryList from './CountryList/index.js';

var RegionTile = function RegionTile(_ref) {
  var countries = _ref.countries,
    regionName = _ref.regionName,
    key = _ref.key,
    selected = _ref.selected,
    onSelectRegion = _ref.onSelectRegion,
    t = _ref.t,
    userLocale = _ref.userLocale;
  return /*#__PURE__*/React.createElement("div", {
    key: key,
    "aria-hidden": "true",
    onClick: function onClick() {
      return onSelectRegion({
        regionName: regionName,
        countries: countries
      });
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    is: "h3"
  }, regionName), /*#__PURE__*/React.createElement(CountryList, {
    countries: countries,
    selected: selected,
    regionName: regionName,
    userLocale: userLocale,
    t: t
  }));
};
RegionTile.defaultProps = {
  countries: [],
  regionName: '',
  key: '',
  selected: '',
  t: {},
  userLocale: {},
  onSelectRegion: function onSelectRegion() {}
};
RegionTile.propTypes = {
  countries: arrayOf(shape({
    countryCode: string
  })),
  regionName: string,
  key: string,
  selected: string,
  onSelectRegion: func,
  userLocale: shape({
    countryName: string,
    regionName: string
  }),
  t: shape({
    signout: string,
    allCountries: string,
    supportLink: string
  })
};

export { RegionTile as default };
